import React, { memo } from "react";

const DashboardChartCard = ({ title, subtitle, children }) => (
  <article className="dashboard-chart-card">
    <header className="dashboard-chart-card-header">
      <h3 className="dashboard-chart-card-title">{title}</h3>
      {subtitle ? <p className="dashboard-chart-card-subtitle">{subtitle}</p> : null}
    </header>
    <div className="dashboard-chart-card-body">{children}</div>
  </article>
);

export default memo(DashboardChartCard);
